import { io, Socket } from 'socket.io-client';

export default class ClientSocket {
  socket: Socket | null | undefined;

  async connect() {
    this.socket = io('https://final-task-backend-production-103d.up.railway.app/');
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  emit<T>(eventName: string, data: T) {
    if (this.socket) {
      this.socket.emit(eventName, data);
    }
  }

  on<T>(eventName: string, func: (data: T) => void) {
    if (this.socket) {
      this.socket.on(eventName, func);
    }
  }
}
